/**
 * Package feature keys that only drive UI visibility (new navigation / tiles) and are NOT
 * something to list on a plan card. They are present on every package since the 6A backend
 * migration; the plan card (FeaturesList, also used by PaymentDialog and UpgradeDialog) must
 * render exactly as it did before they existed, so it drops them BEFORE it slices/counts.
 */
export const UI_ONLY_FEATURE_KEYS = Object.freeze([
  'music', 'create', 'content', 'programs', 'schedule',
  'suggestions', 'quick_show', 'youtube', 'cafe_wizard', 'theme_schedule',
]);
const UI_ONLY = new Set(UI_ONLY_FEATURE_KEYS);
export const isUiOnlyFeatureKey = (k) => UI_ONLY.has(k);
